import {createSvgIcon} from '../create-svg-icon';

export const DehazeIcon = createSvgIcon(
  <path d="M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z" />
, 'DehazeOutlined');
